 // eslint-disable-next-line 

import React, { forwardRef } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";


const ContactUs = forwardRef((props, ref) => {

  const handleSubmit = async (event) => {
    event.preventDefault();

    const formData = {
      name: event.target.formName.value,
      email: event.target.formEmail.value,
      phone: event.target.formPhone.value,
      service: event.target.formService.value,
    };

    try {
      const response = await fetch('https://Rojancanada.com/contactus.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        const result = await response.json();
        alert(result.message); // Show success message
      } else {
        alert('Failed to send your message. Please try again.');
      }
    } catch (error) {
      console.error('Error sending message:', error);
      alert('An error occurred. Please try again.');
    }
    event.target.reset();
  };
  return (
    <>
      <div className="aboutus_bg">
        <div className="aboutus-img-content">
          <h1>Let’s Work Together</h1>

        </div>

      </div>
     

      <Container fluid className="py-5 pt-0 mt-5" style={{ color: "#fff" }} >
        <Row className="align-items-center">
          {/* Left Image */}
          <Col sm={12} md={12} lg={3} className="p-0">
            <div className="form-contactusleft" />
          </Col>

          {/* Inquiry Form */}
          <Col sm={12} md={12} lg={5} className=" Enquiry-bg contact-forming" ref={ref} id="contact-forming">
            <h6 className="mb-3" style={{ color: "#b80505", fontWeight: "bold" }}>
              <i
                className="fa-regular fa-paper-plane"
                style={{
                  color: "#b80505",
                  transform: "rotate(45deg)",
                  marginRight: "10px",
                }}
              ></i>
              CONTACT US
            </h6>
            <h1 className="mb-3" style={{ fontWeight: "700" }}>
              Feel Free To Enquire About Any Question You Got.
            </h1>
            <p className="mb-3 " style={{ color: "#fff", lineHeight: '2', fontWeight: '600' }}>
              {/* Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when
            an unknown printer took a galley of type and scrambled it to make a type specimen book. */}
            </p>
            <Form onSubmit={handleSubmit}>
              
             
                  <Form.Group controlId="formEmail" className="mb-4">
                    <Form.Control type="email" placeholder="Email" required />
                  </Form.Group>
               
                  <Form.Group controlId="formPhone" className="mb-4">
                    <Form.Control type="text" placeholder="Phone" required />
                  </Form.Group>

                  <Form.Group controlId="formName" className="mb-4">
                <Form.Control type="text" placeholder="Location" required />
              </Form.Group>
               
              <Form.Group controlId="formService" className="mb-4">
                <Form.Select required>
                  <option value="" disabled selected hidden>
                    What service are you looking for?
                  </option>
                  <option value="vendor-management-and-pricing">
                    Vendor Management & Strategic Pricing
                  </option>
                  <option value="budgeting-and-overseeing">
                    Budget Planning & Financial Oversight
                  </option>
                  <option value="advertisement-plan-and-strategies">
                    Marketing & Advertising Strategy
                  </option>
                  <option value="advertisement-plan-and-strategies">
                    Administration & Staffing Solutions
                  </option>
                  <option value="advertisement-plan-and-strategies">
                    Restaurant Business Consulting
                  </option>
                  <option value="advertisement-plan-and-strategies">
                    Immigration & Visa Support Services
                  </option>
                  <option value="marketing-branding">
                    Import, Distribution & Delivery
                  </option>
                  <option value="advertisement-plan-and-strategies">
                    Social Media & Digital Advertising
                  </option>
                  <option value="advertisement-plan-and-strategies">
                    Custom Private Label, Printing & Packaging Services
                  </option>
                </Form.Select>
              </Form.Group>
              <h6 className="text-center mb-5">Book your consultation or place your first order today!</h6>
              <Button
                variant="danger"
                type="submit"
                className="w-45"
                style={{
                  background: "#b80505",
                  border: "none",
                  fontWeight: "bold",
                  padding: "15px",
                }}
              >
                SEND NOW
              </Button>
            </Form>
          </Col>

          {/* Right Image */}
          <Col sm={12} md={12} lg={4} className="p-0">
            <div className="form-contactusright" />
          </Col>
        </Row>
      </Container>
    </>
  )
});

export default ContactUs;


 {/* Contact Us Section */}
      {/* <Container className="contactus-container my-5">
        <Row className="">
          
          <Col md={6} className="contactus-image text-center">
            <img
              src="images/dcontact.jpg"
              alt="Customer Service"
              className="img-fluid rounded"
              style={{ maxWidth: "100%", borderRadius: "8px" }}
            />
          </Col>

         
          <Col md={6} className="contactus-info mt-3">
            <h6 className="about-us-title" style={{ fontWeight: "bold", color: "#b80505" }}>
              <i
                className="fa-regular fa-paper-plane"
                style={{
                  color: "#b80505",
                  transform: "rotate(45deg)",
                  marginRight: "10px",
                }}
              ></i>
              GET IN TOUCH <i class="fa-solid fa-earth-americas" style={{ color: '#b50808' }}></i>

            </h6>
            <h1 style={{ marginBottom: "20px", fontWeight: "700" }}>Contact Information</h1>
            <h6 style={{ color: "#6c757d" }}>
              All the Lorem Ipsum generators on the Internet tend to repeat
              predefined chunks as necessary, making this the first on the
              Internet.
            </h6>
            <div className="contactus-details">
              <div className="detail-item d-flex align-items-center mb-4">
                <span className="icon me-3">
                  <i
                    className="fa-solid fa-location-dot fa-xl"
                    style={{ color: "#b80404" }}
                  ></i>
                </span>
                <p className="mb-0">
                  <strong><h5>Our Address:</h5></strong>
                  934 McCowan Road, Toronto M1P 3H6
                </p>
              </div>
              <div className="line"></div>
              <div className="detail-item d-flex align-items-center mb-4">
                <span className="icon me-3">
                  <i
                    className="fa-solid fa-headset fa-xl"
                    style={{ color: "#b80404" }}
                  ></i>
                </span>
                <p className="mb-0">
                  <strong><h5>Free Call Center:</h5></strong>
                  +1 (647) 716-1330
                </p>
              </div>
              <div className="line"></div>
              <div className="detail-item d-flex align-items-center">
                <span className="icon me-3">
                  <i
                    className="fa-solid fa-envelope fa-xl"
                    style={{ color: "#b80404" }}
                  ></i>
                </span>
                <p className="mb-0">
                  <strong><h5>Email Address:</h5></strong>
                  info@rojancanada.com
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container> */}